import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Smart from 'components/Smart';
import ScooterProfile from './Profile';
import NavigationBar from 'components/NavigationBar';
import Pagination from 'components/Pagination';
import CollapseBanner from 'components/CollapseBanner';
import {
    clearSingleScooter,
    fetchCustomerRentalHistory,
    clearCustomerRentalHistory,
    updateDocumentTitle,
    clearVMS,
} from 'actions';
import History, { RENTAL_HISTORY_SCOOTER } from 'components/RentalHistory';

class ScooterDetail extends Component {
    static propTypes = {
        singleScooter: ImmutablePropTypes.map,
        customerHistory: ImmutablePropTypes.map,
        params: PropTypes.shape({}).isRequired,
        onFetch: PropTypes.func.isRequired,
        customAction: PropTypes.func,
    };

    static defaultProps = {
        singleScooter: new Map(),
        customerHistory: undefined,
        customAction: () => {},
    }

    constructor(props) {
        super(props);

        this.queryPayload = {
            scooter_id: undefined,
            page: 1,
            size: 20,
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(updateDocumentTitle('ticket.scooter_title'));

        this.fetchData();
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(clearSingleScooter());
        dispatch(clearVMS());
        dispatch(clearCustomerRentalHistory());
    }

    fetchData = () => {
        const { params, onFetch } = this.props;
        const scooterId = params.scooterId;

        return onFetch(scooterId);
    }

    handleHistoryPageSelect = page => {
        this.queryPayload.page = page;

        this.fetchScooterRentalHistory();
    }

    fetchScooterRentalHistory = () => {
        const { dispatch, singleScooter } = this.props;
        const scooter_id = singleScooter.get('scooter_id');
        if (!scooter_id) {
            return Promise.resolve();
        }

        this.queryPayload.scooter_id = scooter_id;

        return dispatch(fetchCustomerRentalHistory(this.queryPayload));
    };

    render() {
        const { singleScooter, customerHistory, customAction } = this.props;
        const { page_index, page_count, data_list } = customerHistory.toJS();
        const historyHeight = (data_list.length + 1) * 40;

        return (
            <div className="detail-list">
                <div
                    className="form-container scooter-details"
                >
                    <Smart
                        className="scooter-profile-page"
                        fetch={ () => {} }
                        pauseRefresh
                        seamless
                    >
                        <NavigationBar
                            sticky
                            title={ singleScooter.get('plate') }
                            className="navigation-bar"
                            customAction={ customAction }
                        />
                        <ScooterProfile item={ singleScooter.toJS() } />

                        <CollapseBanner
                            className="rental-history-list"
                            captionKey="customer.recent_history"
                            onFetch={ this.fetchScooterRentalHistory }
                        >
                            <Pagination
                                page={ page_index }
                                total={ page_count }
                                offset={ this.queryPayload.size }
                                onSelect={ this.handleHistoryPageSelect }
                                center={ false }
                            />
                            <div style={ { height: historyHeight, width: '100%' } }>
                                <History
                                    history={ data_list }
                                    type={ RENTAL_HISTORY_SCOOTER }
                                />
                            </div>
                        </CollapseBanner>
                    </Smart>
                </div>
            </div>
        );
    };
}

export default connect((state, ownProps) => ({
    singleScooter: state.scooter.get('singleScooter')[ownProps.params.scooterId],
    customerHistory: state.customer.get('history'),
    i18n: state.i18n,
}))(ScooterDetail);
